import useFetchAggregateRevenue from "api/AdminReports/useFetchAggregateRevenue";
import RevenueReportPanel, { useRevenuePeriod } from "components/CurrencyRevenueReport/RevenueReportPanel";

export default function RevenueReport() {
    const { period, setPeriod, query } = useRevenuePeriod();
    const result = useFetchAggregateRevenue(query);
    return <RevenueReportPanel compact {...{ result, period, setPeriod }} ordersLink="/orders" />;
}
